import * as middleware from 'app/blocks/middleware/middleware';

import { REST, GET as DEFAULT_GET, POST as DEFAULT_POST } from './utils';

const { GET, POST, DELETE, PUT } = REST('/userprofile');

export const getProfileCompleteness = (): Promise<string[]> => GET('/profileCompleteness/');

export const getResearchFunders = (): Promise<{
    articles: Array<{ id: string; name: string }>;
    grantNumbers: string[];
    researchFunder: { id: string; name: string };
}> => GET('/researchFunders/');

export const getAlerts = (): Promise<{ alerts: Alert[]; emails: string[]; notificationEmail: string }> =>
    GET('/alerts/');

export const saveAlerts = (alerts): Promise<boolean> => POST('/alerts/', alerts);

export const securityQuestions = (
    email: string,
): Promise<{
    securityDetails: Array<{ securityQuestion: string; securityQuestionId: string }>;
}> => DEFAULT_GET(`/user/securityQuestions/${encodeURIComponent(email)}/`);

export const securityQuestionsList = (): Promise<Array<{ securityQuestion: string; securityQuestionId: string }>> =>
    DEFAULT_GET('/asdata/securityQuestions/');

export const updatePassword = (data: { email: string; oldPassword: string; newPassword: string }): Promise<boolean> =>
    DEFAULT_POST('/user/password/update', data);

export const updateSequrityQuestions = (data): Promise<boolean> => DEFAULT_POST('/user/securityDetails/update', data);

export const getEmailInformation = (): Promise<{ primaryEmailAddr: string; recoveryEmailAddress: string }> =>
    GET('/emailDetails/');

export const getNameTitles = (): Promise<Array<{ id: string; name: string; titleId: string; titleName: string }>> =>
    DEFAULT_GET('/asdata/titles/');

export const getNameSuffixes = (): Promise<Array<{ id: string; name: string; suffixId: string; suffixName: string }>> =>
    DEFAULT_GET('/asdata/suffixes/');

export const getProfileInformation = async (): Promise<Profile> => {
    const response = await GET('/profileInfo/');
    const appinfo = await middleware.appinfo.get();

    response.profileRedirectionURL = appinfo.properties['extsvc.url.profileUrl'];
    return response;
};

export const saveProfileInformation = (data): Promise<void> => POST('/profileInfo/', data);

export const getWOADetails = (): Promise<
    Array<{ woaFunderName: string; articles: Array<{ id: string; name: string }>[] }>
> => GET('/getWOADetails/');

export const getUserAddresses = (): Promise<{
    correspondenceAddress: Address;
    billingAddress: Address;
    shippingAddress?: Address;
}> => GET('/userAddresses/');

export const saveUserAddress = (address): Promise<void> => POST('/userAddresses/', address);

export const addAffiliation = (affiliation): Promise<void> => POST('/affiliations/', affiliation);

export const getAffiliations = (): Promise<Affiliation[]> => GET('/affiliations/');

export const removeAffiliation = (id: string): Promise<void> => DELETE(`/affiliations/${id}/`);

export const saveAffiliation = (id: string, affiliation): Promise<void> =>
    id ? PUT(`/affiliations/${id}/`, affiliation) : POST('/affiliations/', affiliation);

export const getSocieties = (): Promise<Society[]> => GET('/societies/');

export const deleteSociety = (id: string): Promise<void> => DELETE(`/societies/${id}/`);

export const saveSociety = (society): Promise<void> => POST('/societies/', society);
